export const copyToClipboard = (text: string): void => {
  // Taken from: https://stackoverflow.com/questions/33855641/copy-output-of-a-javascript-variable-to-the-clipboard
  const dummy = document.createElement("textarea");
  document.body.appendChild(dummy);
  dummy.value = text;
  dummy.select();
  document.execCommand("copy");
  document.body.removeChild(dummy);
};
